import { useAppNotification } from "@hooks/useAppNotification";
import { AppNotificationModal } from "./AppNotificationModal";

export function FirstCampaignNotification() {
  const { notification, dismiss, close, isDismissing } =
    useAppNotification("first_campaign");

  if (!notification) return null;

  return (
    <AppNotificationModal
      open
      onClose={close}
      onDismiss={dismiss}
      isDismissing={isDismissing}
      title="Houston, we are go for ads."
      description="Here's how this works."
    >
      <div className="space-y-5">
        <div className="flex gap-4 text-sm text-[#2e3238]">
          <div className="flex flex-col items-center gap-1">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              1
            </span>
            <div className="w-px flex-1 bg-[#e0dfdd]" />
          </div>
          <div className="pb-4">
            <span className="font-medium text-[#0f1113]">I write the ads</span>
            <p className="text-[#74767a] text-xs mt-0.5">Headlines, descriptions, and keywords — all tailored to your audience.</p>
          </div>
        </div>
        <div className="flex gap-4 text-sm text-[#2e3238] -mt-3">
          <div className="flex flex-col items-center gap-1">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              2
            </span>
            <div className="w-px flex-1 bg-[#e0dfdd]" />
          </div>
          <div className="pb-4">
            <span className="font-medium text-[#0f1113]">You review and refine</span>
            <p className="text-[#74767a] text-xs mt-0.5">Want punchier copy? Different keywords? Tell me in the chat. Or edit them yourself—I can see your changes just like you can see mine.</p>
          </div>
        </div>
        <div className="flex gap-4 text-sm text-[#2e3238] -mt-3">
          <div className="flex flex-col items-center">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              3
            </span>
          </div>
          <div>
            <span className="font-medium text-[#0f1113]">We launch together</span>
            <p className="text-[#74767a] text-xs mt-0.5">Once you're happy, I deploy everything to Google Ads.</p>
          </div>
        </div>

        <div className="bg-[#f7f6f4] rounded-lg px-4 py-3">
          <p className="text-sm text-[#2e3238]">
            <span className="font-medium">Ask me anything about Google Ads.</span>{" "}
            "What's a good click-through rate?" or "Should I increase my budget?" — I know this stuff.
          </p>
        </div>
      </div>
    </AppNotificationModal>
  );
}
